import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialsModule } from '../../modules/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { InputSearchBoxComponent } from './input-search-box.component';
import { FormFieldsModule } from '../form-fields/form-fields.module';
import { ButtonsModule } from '../buttons/buttons.module';

@NgModule({
  declarations: [InputSearchBoxComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialsModule,
    TranslateModule,
    FormFieldsModule,
    ButtonsModule,
  ],
  exports: [InputSearchBoxComponent],
})
export class InputSearchBoxModule {}
